import { render, staticRenderFns } from "./UnitGeoMovements.vue?vue&type=template&id=f56303f4&scoped=true&"
import script from "./UnitGeoMovements.vue?vue&type=script&lang=js&"
export * from "./UnitGeoMovements.vue?vue&type=script&lang=js&"
import style0 from "./UnitGeoMovements.vue?vue&type=style&index=0&id=f56303f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f56303f4",
  null
  
)

export default component.exports